import { minusIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Minus = createIcon({
  displayName: 'Minus',
  paths: [
    'M810.667 554.667h-597.333c-23.552 0-42.667-19.115-42.667-42.667s19.115-42.667 42.667-42.667h597.333c23.552 0 42.667 19.115 42.667 42.667s-19.115 42.667-42.667 42.667z'
  ],
  canvasPaths: canvasIconPaths(minusIcon)
})
